import moment from "moment";

const DischargesAppliedFormResources = {

    form_data:{
        associate_id: [],
        daily_assignment_id: [],
        date_to_search: moment().format('YYYY-MM-DD'),
        search: ''
    },

    form_format:[
        {
            css_class:  'col-md-4 col-sm-12 pr-3',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Associate:',
            model_name: 'associate_id',
            ref:        'associate_id_input',
            ref_alt:    'associate_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select associate(s)',
            close_on_option: false,
            enable_check_all: true,
            track_by: 'name'
        },
        {
            css_class:  'col-md-4 col-sm-12 pr-3',
            type:       'infinite-scroll-list',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Daily Assignment:',
            model_name: 'daily_assignment_id',
            ref:        'daily_assignment_id_input',
            ref_alt:    'daily_assignment_id_input_alt',
            required:   false,
            search: false,
            parent_class: 'custom-control custom-checkbox w-100',
            input_type: 'checkbox',
            input_class: 'custom-control-input',
            label_input_class: 'custom-control-label reports__show-hide__label ml-2',
            placeholder: 'Select daily assignment(s)',
            close_on_option: false,
            enable_check_all: true,
            track_by: 'name'
        },
        {
            css_class:  'col-md-4 col-sm-12 pr-3',
            type:       'date',
            maxlength:  '',
            disabled:   false,
            step:       '',
            name:       'Date:',
            model_name: 'date_to_search',
            ref:        'date_to_search_input',
            ref_alt:    'date_to_search_input_alt',
            required:   true,
        },
    ],

}

export default DischargesAppliedFormResources;